import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-emp-allowance',
  templateUrl: './emp-allowance.component.html',
  styleUrls: ['./emp-allowance.component.css']
})
export class EmpAllowanceComponent implements OnInit {

  model = {
    'table_name': 'emp_allowance', 'allow_id': '0', 'main_acct_no': '', 'allow_name': '', 'allow_name_en': '',
    'allow_perc': '', 'is_goci': 0, 'comment': ''
  };

  main_acct_model = {
    'table_name': 'main_acct', 'acct_type_no': '8', 'main_acct_name': '',
    'main_acct_name_en': '', 'main_acct_number': ''
  };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<EmpAllowanceComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['allow_name'] == '') {
      alert(" الرجاء إدخال نوع البدل ");
      (document.getElementById('allow_name') as HTMLInputElement).focus();
    }
    else {
      if (this.model['is_goci']) this.model['is_goci'] = 1; else this.model['is_goci'] = 0;

      let values = [];
      let obj;
      if (this.model['allow_id'] == '0') {
        let query = "SELECT MAX(`main_acct_number`) as 'max_number' FROM `main_acct` WHERE `status` = 1 AND `acct_type_no` = '8'";
        let obj1 = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let max_number = Number(data.data['list'][0].max_number);
            if (max_number > 0) // not first item
              this.model['main_acct_no'] = String(max_number + 1);
            else // first account in this type
              this.model['main_acct_no'] = String(8 * 100 + 1);
            //console.log(this.acctTypes);

            values.push(this.model);

            this.main_acct_model['main_acct_name'] = this.model['allow_name'];
            this.main_acct_model['main_acct_name_en'] = this.model['allow_name_en'];
            this.main_acct_model['main_acct_number'] = this.model['main_acct_no'];
            values.push(this.main_acct_model);

            obj = { cmd: 'add', values: values };

            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                if (data.status['type'] == 'success') {
                  alert(" تمت العملية بنجاح ");
                  this.dialog_data = {
                    'status': data.status['type']
                  };
                  this.dialogRef.close(this.dialog_data);
                }
                else {
                  alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
                }
              });
          });
      }
      else {
        values.push(this.model);
        let where = [{ 'allow_id': this.model['allow_id'] }];
        obj = { cmd: 'update', values: values, where: where };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(" تمت العملية بنجاح ");
              this.dialogRef.close(this.dialog_data);
            }
            else {
              alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
            }
          });
      }

    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }


}
